/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserPreferenceGetRequest {
    getFixupPrototypeFunction() { return UserPreferenceGetRequest.fixupPrototype; }

    static newInstance(model: Partial<UserPreferenceGetRequest>): UserPreferenceGetRequest {
        let obj = Object.assign(new UserPreferenceGetRequest(), model);
        UserPreferenceGetRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserPreferenceGetRequest>): UserPreferenceGetRequest {
        if (!model) return null;
        return UserPreferenceGetRequest.newInstance(<UserPreferenceGetRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserPreferenceGetRequest) {
        if (!obj) return;

        models.UserPreferenceGetRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserPreferenceGetRequest): boolean {
        Object.setPrototypeOf(obj, UserPreferenceGetRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Path of the user preference
     */
    path: string;

    /**
     * Name of the user preference
     */
    name: string;

}
